import TextHandWritingController from './text';

/**
 * 英字入力用のコントローラ
 * TextHandWritingControllerから派生する。
 * 
 * [依存関係]
 * TextHandWritingController
 * 
 * @param {*} $scope 
 */
export default function($scope) {
  TextHandWritingController($scope);

  /**
   * 受信結果解析後の処理
   * @param {object} param event オブジェクトに以下の情報を加えたデータ
   * @param {string} param.printId DOMのIDから抽出したプリントID。既存処理に必要。
   * @param {string} param.exportedChar exports[text/plain] の文字
   * @param {object} param.exportedJiix 認識結果
   */
  $scope.afterExported = function(param) {
    // 英字入力は単一候補を渡す。
    const exportedText = $scope.getExportedData(param);
    selectDrawingAnswer(param.printId, exportedText, RECOGNITION.language_en);
  }

  /**
   * 認識エンジン結果を返す。アプリに必要な調整を加える場合あり。
   * ・大文字小文字指定なしの場合は、描いた位置によって大文字｜小文字判定する
   *    ・小文字判定エリアに書かれた場合は、小文字変換対象を小文字に変換する。
   *    ・小文字判定エリア以外で受信結果が１文字だった場合、大文字変換対象を大文字に変換する
   * ・上記以外は認識エンジンの結果をそのまま返す
   * @param {object} param event オブジェクトに以下の情報を加えたデータ
   * @returns {string} 認識エンジンの結果文字列、または調整済み文字列
   */
  $scope.getExportedData = (param) => {
    const text = param.exportedChar || "";
    // 大文字小文字指定なしの場合のみ
    if (inputType == InputType.HandEn || inputType == InputType.HandAndKeyEn) {
      // 下半分に書かれた場合は小文字判定
      if (drawingTextSide == CANVAS_CORNER.LEFT_BOTTOM ||
        drawingTextSide == CANVAS_CORNER.RIGHT_BOTTOM ||
        drawingTextSide == CANVAS_CORNER.ONLY_BOTTOM
      ){
        let replaced = '';
        for (let i = 0; i < text.length; ++i) {
          let char = text.charAt(i);
          replaced += ENGLISH_LOWER_CHARACTERS.indexOf(char.toLowerCase()) > -1
          ? char.toLowerCase()
          : char;
        }
        return replaced;
      }
      // 受信結果が１文字の小文字だった場合、大文字判定し、必要なら小文字→大文字に変換する
      else if (text.length === 1 && ENGLISH_LOWER_CHARACTERS.indexOf(text) > -1) {
        // 手書きの縦の範囲が中央線の上下に跨ってたら、大文字を入力された、と判定する
        const centerPos = param.target.clientHeight *0.5;
        const margin = param.target.clientHeight *0.1;
        if ($scope.drawing.strokeMin.y <= centerPos - margin &&
          $scope.drawing.strokeMax.y >= centerPos + margin
        ){
          return text.toUpperCase();
        }
      }
    }

    // 上記以外は認識エンジンの結果をそのまま返す
    return text;
  }
}